import React from 'react';
import { Link } from 'react-router-dom';
import PageIntro from '../components/PageIntro';
import { usePageMeta, SITE_NAME } from '../lib/usePageMeta';

const offers = [
  'Word meanings and definitions',
  'Educational articles and learning resources',
  'Simple explanations for complex topics',
  'Helpful content for students and teachers',
  'Knowledge resources for professionals and general readers',
];

const reasons = [
  'Easy-to-understand content',
  'Educational resources for all age groups',
  'Professional and reader-friendly information',
  'Continuously updated learning materials',
  'Accessible worldwide',
];

const AboutUs = () => {
  usePageMeta(
    `About Us | ${SITE_NAME}`,
    'Definitionofthe.com is an online dictionary and learning site with clear definitions for students, teachers and everyday readers.'
  );

  return (
    <div className="wrap pt-12 md:pt-16">
      <PageIntro title="About definitionofthe">
        Your online place for meanings, definitions and plain explanations, made for anyone who stops on a
        word and wants to know what it means.
      </PageIntro>

      <div className="mt-12 max-w-2xl space-y-5 font-serif text-lg leading-[1.75]">
        <p>
          At Definitionofthe.com, we believe that education and understanding should be accessible to all
          people around the world. Our mission is to provide clear, accurate, and easy-to-understand information
          that helps students, teachers, professionals, and everyday learners expand their knowledge and improve
          their understanding of words, concepts, and educational topics.
        </p>
        <p>
          We are dedicated to creating high-quality educational and dictionary-based content that is useful,
          informative, and beginner-friendly. Whether you are a student searching for definitions, a teacher
          looking for learning resources, a professional improving communication skills, or simply someone curious
          to learn something new, Definitionofthe.com is built to support your learning journey.
        </p>
      </div>

      <div className="mt-14 grid max-w-4xl gap-12 border-t border-rule pt-12 md:grid-cols-2">
        <section>
          <h2 className="font-serif text-2xl font-semibold">What we offer</h2>
          <ul className="mt-4 list-disc space-y-2 pl-5 marker:text-ink-soft">
            {offers.map((item) => <li key={item}>{item}</li>)}
          </ul>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold">Why people use it</h2>
          <ul className="mt-4 list-disc space-y-2 pl-5 marker:text-ink-soft">
            {reasons.map((item) => <li key={item}>{item}</li>)}
          </ul>
        </section>
      </div>

      <section className="mt-14 max-w-2xl border-t border-rule pt-12">
        <h2 className="font-serif text-2xl font-semibold">Our mission</h2>
        <p className="mt-4 font-serif text-lg leading-[1.75]">
          Our goal is to make learning simple, accessible, and valuable for everyone regardless of background,
          profession, or location. We continuously work to provide informative and trustworthy content that
          supports education and personal growth worldwide.
        </p>
        <Link
          to="/dictionary"
          className="mt-8 inline-flex h-12 items-center rounded-md bg-ink px-6 font-medium text-paper transition-colors hover:bg-ink/85"
        >
          Search the dictionary
        </Link>
      </section>
    </div>
  );
};

export default AboutUs;
